import { useEffect } from 'react';
import cloneDeep from 'lodash/fp/cloneDeep';

import {
  productImpression,
  productAddedToCart,
  productRemovedFromCart,
  cartDidViewCheckout,
  cartDidPurchase,
} from 'utils/ecommerce-analytics';

// Unused, but here if needed
export default function useEcommerceAnalytics() {
  return {
    productImpression,
    productAddedToCart,
    productRemovedFromCart,
    cartDidViewCheckout,
    cartDidPurchase,
  };
}

export function useViewedCheckoutAnalytics({ cart, isLoading = false }) {
  useEffect(() => {
    if (cart.isReady && !isLoading) {
      cartDidViewCheckout(cloneDeep(cart));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart.isReady, isLoading]);
}

export function useViewedProductAnalytics({ product, cart }) {
  useEffect(() => {
    productImpression(product, cart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);
}
